// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__6avMV","ranges":"BmiRanges_ranges__3S_X7"};